module.exports = __webpack_public_path__ + "static/media/diaper11-29.1d1d9860.png";